import { render, staticRenderFns } from "./DetailCharge.vue?vue&type=template&id=73398624"
import script from "./DetailCharge.vue?vue&type=script&lang=ts"
export * from "./DetailCharge.vue?vue&type=script&lang=ts"
import style0 from "./DetailCharge.vue?vue&type=style&index=0&id=73398624&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports